import { render, staticRenderFns } from "./man.vue?vue&type=template&id=3e48fdd9&scoped=true&"
import script from "./man.vue?vue&type=script&lang=js&"
export * from "./man.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e48fdd9",
  null
  
)

export default component.exports